import { createLazyImports } from '../../global/lazyLoad/lazyLoadUtils';

const componentPaths = {
    LazySubmitReservationButton: () =>
        import(/* webpackChunkName: 'cmp-submitReservationButton' */ '../../global/atoms/SubmitReservation'),
    LazyCheckoutGuestUser: () => import(/* webpackChunkName: 'cmp-checkoutGuestUser' */ '../CheckoutGuestUser'),
    LazyCheckoutCashUser: () => import(/* webpackChunkName: 'cmp-checkoutCashUser' */ '../CheckoutCashUser'),
    LazyCheckoutCreditUser: () => import(/* webpackChunkName: 'cmp-checkoutCreditUser' */ '../CheckoutCreditUser'),
    LazyQuotesGuestUser: () => import(/* webpackChunkName: 'cmp-quotesGuestUser' */ '../QuotesGuestUser'),
    LazyQuotesCashUser: () => import(/* webpackChunkName: 'cmp-quotesCashUser' */ '../QuotesCashUser'),
    LazyQuotesCreditUser: () => import(/* webpackChunkName: 'cmp-quotesCreditUser' */ '../QuotesCreditUser'),
    LazyReservationConfirmation: () => import(/* webpackChunkName: 'cmp-reservationConfirmation' */ '../confirmation'),
    LazyQuoteSuccessConfirmation: () => import(/* webpackChunkName: 'cmp-reservationConfirmation' */ '../confirmation/QuoteConfirmation'),
    LazyQuoteConfirmation: () =>
        import(
            /* webpackChunkName: 'cmp-quoteConfirmation' */ '../../checkoutv2/transmitOrSave/QuoteConfirmation/QuoteConfirmation'
        ),
    LazyQuoteTransmitModal: () =>
        import(/* webpackChunkName: 'cmp-quoteTransmitModal' */ '../../quotes/qouteTransmitModal/QuoteTransmitModal'),
    LazyTransmitOrSaveMain: () =>
        import(/* webpackChunkName: 'cmp-transmitOrSaveMain' */ '../../checkoutv2/transmitOrSave/TransmitOrSaveMain'),
    LazyCheckoutStepsAndOrderSummary: () =>
        import(/* webpackChunkName: 'cmp-checkoutStepsAndOrderSummary' */ '../CheckoutStepsAndOrderSummary'),
    LazyGenerateQuote: () => import(/* webpackChunkName: 'cmp-generateQuote' */ '../generateQuote'),
};

const LazyLoadCheckoutImports = createLazyImports(componentPaths);

export const {
    LazySubmitReservationButton,
    LazyCheckoutGuestUser,
    LazyCheckoutCashUser,
    LazyCheckoutCreditUser,
    LazyQuotesGuestUser,
    LazyQuotesCashUser,
    LazyQuotesCreditUser,
    LazyReservationConfirmation,
    LazyQuoteConfirmation,
    LazyQuoteTransmitModal,
    LazyTransmitOrSaveMain,
    LazyCheckoutStepsAndOrderSummary,
    LazyGenerateQuote,
    LazyQuoteSuccessConfirmation
} = LazyLoadCheckoutImports;